/**
 * FirebaseAnalytics.web.js — STUB no-op pour le bundle web.
 *
 * Metro résout automatiquement ce fichier (`.web.js`) sur la plateforme web,
 * et `FirebaseAnalytics.native.js` sur iOS/Android. Le SDK natif
 * @react-native-firebase n'est donc JAMAIS importé dans le bundle web
 * (où il n'a pas de sens et casserait l'export expo web).
 *
 * Le tracking web continue de passer par gtag.js (cf AnalyticsService.js).
 */
export function isFirebaseReady() { return false; }
export async function setFirebaseCollection() {}
export async function logFirebaseEvent() {}
export async function setFirebaseUserId() {}
